// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var Common = require("../utils/Common.res.js");
var Js_exn = require("rescript/lib/js/js_exn.js");
var Belt_Int = require("rescript/lib/js/belt_Int.js");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Core__Math = require("@rescript/core/src/Core__Math.res.js");
var MM_context = require("../mm-utils/MM_context.res.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Core__Array = require("@rescript/core/src/Core__Array.res.js");
var Belt_HashMap = require("rescript/lib/js/belt_HashMap.js");
var Core__Option = require("@rescript/core/src/Core__Option.res.js");
var MM_wrk_unify = require("../worker/MM_wrk_unify.res.js");
var MM_wrk_client = require("../worker/MM_wrk_client.res.js");
var MM_wrk_editor = require("../worker/MM_wrk_editor.res.js");
var Expln_React_Row = require("../../rescript-utils/main/react-mui-components/Expln_React_Row.res.js");
var MM_react_common = require("../ui-utils/MM_react_common.res.js");
var MM_substitution = require("../mm-utils/MM_substitution.res.js");
var MM_cmp_user_stmt = require("./MM_cmp_user_stmt.res.js");
var Expln_React_Modal = require("../../rescript-utils/main/react-components/Expln_React_Modal.res.js");
var MM_cmp_proof_tree = require("./MM_cmp_proof_tree.res.js");
var MM_cmp_root_stmts = require("./MM_cmp_root_stmts.res.js");
var MM_statements_dto = require("../mm-utils/MM_statements_dto.res.js");
var Expln_React_Column = require("../../rescript-utils/main/react-mui-components/Expln_React_Column.res.js");
var Expln_React_common = require("../../rescript-utils/main/Expln_React_common.res.js");
var Expln_utils_common = require("../../rescript-utils/main/Expln_utils_common.res.js");
var Paper = require("@mui/material/Paper").default;
var Radio = require("@mui/material/Radio").default;
var Expln_utils_promise = require("../../rescript-utils/main/Expln_utils_promise.res.js");
var Button = require("@mui/material/Button").default;
var Select = require("@mui/material/Select").default;
var Divider = require("@mui/material/Divider").default;
var Checkbox = require("@mui/material/Checkbox").default;
var MenuItem = require("@mui/material/MenuItem").default;
var TextField = require("@mui/material/TextField").default;
var AutocompleteVirtualized = require("../ui-utils/AutocompleteVirtualized.res.js");
var IconButton = require("@mui/material/IconButton").default;
var InputLabel = require("@mui/material/InputLabel").default;
var Pagination = require("@mui/material/Pagination").default;
var RadioGroup = require("@mui/material/RadioGroup").default;
var Pause = require("@mui/icons-material/Pause").default;
var FormControl = require("@mui/material/FormControl").default;
var MM_bottom_up_prover_params = require("../mm-utils/MM_bottom_up_prover_params.res.js");
var Warning = require("@mui/icons-material/Warning").default;
var FormControlLabel = require("@mui/material/FormControlLabel").default;
var DisplaySettings = require("@mui/icons-material/DisplaySettings").default;

function getProofStatus(stmt) {
  if (stmt.isHyp) {
    return "Ready";
  } else {
    return stmt.proofStatus;
  }
}

function exprMayMatchAsrt(expr, frm, parenCnt) {
  if (expr[0] !== frm.frame.asrt[0]) {
    return false;
  }
  var res = {
    contents: false
  };
  MM_substitution.iterateSubstitutions(frm.frame.asrt, expr, frm.frmConstParts[frm.numOfHypsE], frm.constParts[frm.numOfHypsE], frm.varGroups[frm.numOfHypsE], frm.subs, parenCnt, (function (param) {
          res.contents = true;
          return "Stop";
        }));
  return res.contents;
}

function getAvailableAsrtLabels(frms, parenCnt, exprToProve) {
  var availableAsrtLabels = [];
  MM_substitution.frmsForEach(frms, undefined, (function (frm) {
          if (exprMayMatchAsrt(exprToProve, frm, parenCnt)) {
            availableAsrtLabels.push(frm.frame.label);
            return ;
          }
          
        }));
  return availableAsrtLabels;
}

function makeInitialState(rootUserStmts, frms, parenCnt, initialParams, initialDebugLevel, allowedFrms, bottomUpProverDefaults) {
  var rootStmts = rootUserStmts.map(MM_wrk_editor.userStmtToRootStmt);
  var rootStmtsLen = rootStmts.length;
  var maxRootStmtIdx = rootStmtsLen - 1 | 0;
  var exprToProve = rootStmts[maxRootStmtIdx].expr;
  var possibleArgs = rootStmts.filter(function (param, i) {
          return i < maxRootStmtIdx;
        }).map(function (stmt) {
        return stmt.expr;
      });
  var params = initialParams !== undefined ? initialParams : MM_bottom_up_prover_params.bottomUpProverParamsMakeDefault(undefined, bottomUpProverDefaults.searchDepth, Core__Option.getOr(MM_bottom_up_prover_params.lengthRestrictFromStr(bottomUpProverDefaults.lengthRestrict), "Less"), bottomUpProverDefaults.allowNewDisjForExistingVars, bottomUpProverDefaults.allowNewStmts, bottomUpProverDefaults.allowNewVars, undefined, undefined, undefined);
  var frameParams = params.assertionParams;
  var frameParamsLen = frameParams.length;
  return {
          rootUserStmts: rootUserStmts,
          rootStmts: rootStmts,
          rootStmtsRendered: rootUserStmts.filter(function (param, i) {
                  return i < maxRootStmtIdx;
                }).map(function (stmt) {
                var expr = stmt.expr;
                var tmp;
                if (expr !== undefined) {
                  tmp = expr;
                } else {
                  throw {
                        RE_EXN_ID: Common.MmException,
                        _1: {
                          msg: "expr must be set on a root statement."
                        },
                        Error: new Error()
                      };
                }
                return {
                        id: stmt.id,
                        expr: tmp,
                        isHyp: stmt.typ === "E",
                        label: stmt.label,
                        proofStatus: stmt.proofStatus,
                        exprReElem: React.createElement("span", undefined, MM_cmp_user_stmt.rndContText(stmt.cont, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined))
                      };
              }),
          exprToProve: exprToProve,
          title: React.createElement("span", undefined, React.createElement("span", {
                    style: {
                      fontWeight: "bold"
                    }
                  }, "Proving bottom-up "), MM_cmp_user_stmt.rndContText(rootUserStmts[maxRootStmtIdx].cont, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined)),
          initialParams: params,
          args0: possibleArgs.map(function (possibleArg) {
                if (frameParamsLen > 0) {
                  return frameParams[0].deriveFrom.some(function (arg) {
                              return MM_context.exprEq(arg, possibleArg);
                            });
                } else {
                  return false;
                }
              }),
          args1: possibleArgs.map(function (possibleArg) {
                if (frameParamsLen > 1) {
                  return frameParams[1].deriveFrom.some(function (arg) {
                              return MM_context.exprEq(arg, possibleArg);
                            });
                } else {
                  return false;
                }
              }),
          args1EqArgs0: false,
          availableLabels: getAvailableAsrtLabels(frms, parenCnt, exprToProve),
          label: frameParamsLen > 0 ? Belt_Option.flatMap(frameParams[0].assertionsToUse, (function (arr) {
                    if (arr.length > 0) {
                      return arr[0];
                    }
                    
                  })) : undefined,
          depth: params.maxSearchDepth,
          depthStr: String(params.maxSearchDepth),
          lengthRestrict: frameParamsLen > 1 ? frameParams[1].statementLengthRestriction : "Less",
          allowNewDisjForExistingVars: frameParamsLen > 0 ? frameParams[0].allowNewDisjointsForExistingVariables : true,
          allowNewStmts: frameParamsLen > 0 ? frameParams[0].allowNewStatements : true,
          allowNewVars: frameParamsLen > 0 ? frameParams[0].allowNewVariables : false,
          useDisc: allowedFrms.inEssen.useDisc,
          useDepr: allowedFrms.inEssen.useDepr,
          useTranDepr: allowedFrms.inEssen.useTranDepr,
          debugLevel: Core__Option.getOr(Core__Option.map(initialDebugLevel, (function (lvl) {
                      if (0 <= lvl && lvl <= 2) {
                        return lvl;
                      } else {
                        return bottomUpProverDefaults.debugLevel;
                      }
                    })), bottomUpProverDefaults.debugLevel),
          maxNumberOfBranchesStr: frameParamsLen > 0 ? Belt_Option.getWithDefault(Belt_Option.map(frameParams[0].maxNumberOfBranches, (function (prim) {
                        return String(prim);
                      })), "") : "",
          proverParamsToShow: undefined,
          tree: undefined,
          warnings: [],
          results: undefined,
          resultsRendered: undefined,
          sortBy: "NewStmtsNum",
          resultsSorted: undefined,
          resultsPerPage: 20,
          resultsMaxPage: 0,
          resultsPage: 0,
          checkedResultIdx: undefined,
          resultForApiCallHasBeenSelected: false,
          showApiParams: false
        };
}

function setLabel(st, label) {
  var newrecord = Caml_obj.obj_dup(st);
  newrecord.label = label;
  return newrecord;
}

function setDepthStr(st, depthStr) {
  var newrecord = Caml_obj.obj_dup(st);
  newrecord.depthStr = depthStr;
  return newrecord;
}

function setLengthRestrict(st, lengthRestrict) {
  var newrecord = Caml_obj.obj_dup(st);
  newrecord.lengthRestrict = lengthRestrict;
  return newrecord;
}

function toggleAllowNewDisjForExistingVars(st) {
  var newrecord = Caml_obj.obj_dup(st);
  newrecord.allowNewDisjForExistingVars = !st.allowNewDisjForExistingVars;
  return newrecord;
}

function toggleAllowNewStmts(st) {
  var newrecord = Caml_obj.obj_dup(st);
  newrecord.allowNewStmts = !st.allowNewStmts;
  return newrecord;
}

function toggleAllowNewVars(st) {
  var newrecord = Caml_obj.obj_dup(st);
  newrecord.allowNewVars = !st.allowNewVars;
  return newrecord;
}

function toggleArgs1EqArgs0(st) {
  var newrecord = Caml_obj.obj_dup(st);
  newrecord.args1EqArgs0 = !st.args1EqArgs0;
  return newrecord;
}

function toggleUseDisc(st) {
  var newrecord = Caml_obj.obj_dup(st);
  newrecord.useDisc = !st.useDisc;
  return newrecord;
}

function toggleUseDepr(st) {
  var newrecord = Caml_obj.obj_dup(st);
  newrecord.useDepr = !st.useDepr;
  return newrecord;
}

function toggleUseTranDepr(st) {
  var newrecord = Caml_obj.obj_dup(st);
  newrecord.useTranDepr = !st.useTranDepr;
  return newrecord;
}

function setDebugLevel(st, debugLevel) {
  var newrecord = Caml_obj.obj_dup(st);
  newrecord.debugLevel = 0 <= debugLevel && debugLevel <= 2 ? debugLevel : 0;
  return newrecord;
}

function toggleShowApiParams(st) {
  var newrecord = Caml_obj.obj_dup(st);
  newrecord.showApiParams = !st.showApiParams;
  return newrecord;
}

function setResultForApiCallHasBeenSelected(st) {
  var newrecord = Caml_obj.obj_dup(st);
  newrecord.resultForApiCallHasBeenSelected = true;
  return newrecord;
}

var nonDigitPattern = /\D/g;

function setMaxNumberOfBranchesStr(st, maxNumberOfBranchesStr) {
  var newrecord = Caml_obj.obj_dup(st);
  newrecord.maxNumberOfBranchesStr = maxNumberOfBranchesStr.replace(nonDigitPattern, "");
  return newrecord;
}

function selectAllArgs(args) {
  return args.map(function (param) {
              return true;
            });
}

function unselectAllArgs(args) {
  return args.map(function (param) {
              return false;
            });
}

function updateArgs0(st, args0) {
  var newrecord = Caml_obj.obj_dup(st);
  newrecord.args0 = args0;
  return newrecord;
}

function updateArgs1(st, args1) {
  var newrecord = Caml_obj.obj_dup(st);
  newrecord.args1 = args1;
  return newrecord;
}

function isStmtToShow(stmt, rootJstfs) {
  var match = Belt_HashMap.get(rootJstfs, stmt.expr);
  if (match === undefined) {
    return true;
  }
  var rootJstf = Caml_option.valFromOption(match);
  if (rootJstf === undefined) {
    return Belt_Option.isSome(stmt.jstf);
  }
  var foundJstf = stmt.jstf;
  if (foundJstf !== undefined) {
    return !MM_statements_dto.jstfEq(rootJstf, foundJstf);
  } else {
    return false;
  }
}

function stmtsDtoToResultRendered(stmtsDto, idx, isStmtToShow, getFrmLabelBkgColor) {
  var maxI = stmtsDto.stmts.length - 1 | 0;
  var stmtsToShow = stmtsDto.stmts.filter(function (stmt, i) {
        if (i === maxI) {
          return true;
        } else {
          return isStmtToShow(stmt);
        }
      });
  var elem = React.createElement(Expln_React_Column.make, {
        children: Caml_option.some(null)
      }, stmtsDto.newDisjStr.map(function (disjStr) {
            return React.createElement("span", {
                        key: disjStr
                      }, disjStr);
          }), React.createElement("table", undefined, React.createElement("tbody", undefined, stmtsToShow.map(function (stmt) {
                    var match = stmt.jstf;
                    var tmp;
                    if (match !== undefined) {
                      var label = match.label;
                      var tmp$1 = {
                        borderRadius: "3px"
                      };
                      var tmp$2 = getFrmLabelBkgColor(label);
                      if (tmp$2 !== undefined) {
                        tmp$1.backgroundColor = tmp$2;
                      }
                      tmp = React.createElement(React.Fragment, {}, React.createElement("span", undefined, "[" + match.args.join(" ") + " : "), React.createElement("span", {
                                style: tmp$1
                              }, label), React.createElement("span", undefined, " ]"));
                    } else {
                      tmp = null;
                    }
                    return React.createElement("tr", {
                                key: stmt.exprStr
                              }, React.createElement("td", undefined, stmt.label), React.createElement("td", {
                                    style: {
                                      textAlign: "right"
                                    }
                                  }, React.createElement("nobr", undefined, tmp)), React.createElement("td", {
                                    style: {
                                      color: stmt.isProved ? "green" : "#565656",
                                      fontWeight: "bold"
                                    }
                                  }, stmt.isProved ? "\u2713" : "?"), React.createElement("td", undefined, stmt.exprStr));
                  }))));
  var lastStmt = stmtsDto.stmts[stmtsDto.stmts.length - 1 | 0];
  return {
          idx: idx,
          elem: elem,
          isProved: lastStmt.isProved,
          asrtLabel: Belt_Option.getWithDefault(Belt_Option.map(lastStmt.jstf, (function (jstf) {
                      return jstf.label;
                    })), ""),
          numOfNewVars: stmtsDto.newVars.length,
          numOfUnprovedStmts: Core__Array.reduce(stmtsDto.stmts, 0, (function (cnt, stmt) {
                  return cnt + (
                          stmt.isProved ? 0 : 1
                        ) | 0;
                })),
          numOfStmts: stmtsToShow.length
        };
}

var compareByIsProved = Expln_utils_common.comparatorByInt(function (res) {
      if (res.isProved) {
        return 0;
      } else {
        return 1;
      }
    });

var compareByNumberOfStmts = Expln_utils_common.comparatorByInt(function (res) {
      return res.numOfStmts;
    });

var compareByNumOfUnprovedStmts = Expln_utils_common.comparatorByInt(function (res) {
      return res.numOfUnprovedStmts;
    });

var compareByNumOfNewStmts = Expln_utils_common.comparatorByInt(function (res) {
      return res.numOfStmts;
    });

var compareByNumOfNewVars = Expln_utils_common.comparatorByInt(function (res) {
      return res.numOfNewVars;
    });

function compareByAsrtLabel(a, b) {
  return a.asrtLabel.localeCompare(b.asrtLabel);
}

function createComparator(sortBy) {
  var mainCmp;
  switch (sortBy) {
    case "NewStmtsNum" :
        mainCmp = compareByNumOfNewStmts;
        break;
    case "UnprovedStmtsNum" :
        mainCmp = compareByNumOfUnprovedStmts;
        break;
    case "NumOfNewVars" :
        mainCmp = compareByNumOfNewVars;
        break;
    case "AsrtLabel" :
        mainCmp = compareByAsrtLabel;
        break;
    
  }
  return Expln_utils_common.comparatorAndThen(Expln_utils_common.comparatorAndThen(Expln_utils_common.comparatorAndThen(compareByIsProved, mainCmp), compareByNumberOfStmts), compareByAsrtLabel);
}

function sortResultsRendered(resultsRendered, sortBy) {
  return Belt_Option.map(resultsRendered, (function (resultsRendered) {
                return Expln_utils_common.sortInPlaceWith(resultsRendered.slice(), createComparator(sortBy));
              }));
}

function isTruncatedSearchErr(src) {
  if (typeof src !== "object") {
    return false;
  }
  if (src.TAG !== "AssertionWithErr") {
    return false;
  }
  var tmp = src.err;
  if (typeof tmp !== "object" || tmp.TAG !== "TooManyCombinations") {
    return false;
  } else {
    return true;
  }
}

function findWarnings(tree) {
  if (tree.nodes.some(function (n) {
          return n.parents.some(isTruncatedSearchErr);
        })) {
    return ["The search space was truncated due to some assertions produce too big search space. Use Logging level = 1 and then click 'Show Proof Tree' button to find those assertions."];
  } else {
    return [];
  }
}

function setResults(st, tree, warnings, results, getFrmLabelBkgColor) {
  if (results !== undefined && results.TAG === "Ok") {
    var results$1 = results._0;
    var rootJstfs = Belt_HashMap.fromArray(st.rootStmts.map(function (stmt) {
              return [
                      stmt.expr,
                      stmt.jstf
                    ];
            }), MM_context.ExprHash);
    var isStmtToShow$1 = function (stmt) {
      return isStmtToShow(stmt, rootJstfs);
    };
    var resultsRendered = results$1.map(function (dto, i) {
          return stmtsDtoToResultRendered(dto, i, isStmtToShow$1, getFrmLabelBkgColor);
        });
    var newrecord = Caml_obj.obj_dup(st);
    newrecord.checkedResultIdx = undefined;
    newrecord.resultsPage = 1;
    newrecord.resultsMaxPage = Core__Math.Int.ceil(results$1.length / st.resultsPerPage);
    newrecord.resultsSorted = sortResultsRendered(resultsRendered, st.sortBy);
    newrecord.resultsRendered = resultsRendered;
    newrecord.results = {
      TAG: "Ok",
      _0: results$1
    };
    newrecord.warnings = warnings;
    newrecord.tree = tree;
    return newrecord;
  }
  var newrecord$1 = Caml_obj.obj_dup(st);
  newrecord$1.checkedResultIdx = undefined;
  newrecord$1.resultsPage = 0;
  newrecord$1.resultsMaxPage = 0;
  newrecord$1.resultsSorted = undefined;
  newrecord$1.resultsRendered = undefined;
  newrecord$1.results = results;
  newrecord$1.warnings = warnings;
  newrecord$1.tree = undefined;
  return newrecord$1;
}

function setSortBy(st, sortBy) {
  var newrecord = Caml_obj.obj_dup(st);
  newrecord.checkedResultIdx = undefined;
  newrecord.resultsPage = 1;
  newrecord.resultsSorted = sortResultsRendered(st.resultsRendered, sortBy);
  newrecord.sortBy = sortBy;
  return newrecord;
}

function setPage(st, page) {
  var newrecord = Caml_obj.obj_dup(st);
  newrecord.resultsPage = page;
  return newrecord;
}

function toggleResultChecked(st, idx) {
  var checkedIdx = st.checkedResultIdx;
  if (checkedIdx !== undefined) {
    if (checkedIdx !== idx) {
      var newrecord = Caml_obj.obj_dup(st);
      newrecord.checkedResultIdx = idx;
      return newrecord;
    }
    var newrecord$1 = Caml_obj.obj_dup(st);
    newrecord$1.checkedResultIdx = undefined;
    return newrecord$1;
  }
  var newrecord$2 = Caml_obj.obj_dup(st);
  newrecord$2.checkedResultIdx = idx;
  return newrecord$2;
}

function sortByToStr(sortBy) {
  switch (sortBy) {
    case "NewStmtsNum" :
        return "NewStmtsNum";
    case "UnprovedStmtsNum" :
        return "UnprovedStmtsNum";
    case "NumOfNewVars" :
        return "NumOfNewVars";
    case "AsrtLabel" :
        return "AsrtLabel";
    
  }
}

function sortByFromStr(str) {
  switch (str) {
    case "AsrtLabel" :
        return "AsrtLabel";
    case "NewStmtsNum" :
        return "NewStmtsNum";
    case "NumOfNewVars" :
        return "NumOfNewVars";
    case "UnprovedStmtsNum" :
        return "UnprovedStmtsNum";
    default:
      throw {
            RE_EXN_ID: Common.MmException,
            _1: {
              msg: "Cannot convert value of '" + str + "' to a sortBy."
            },
            Error: new Error()
          };
  }
}

function rndCheckboxWithLabelAndBorder(checked, onChange, label) {
  return React.createElement(FormControlLabel, {
              control: React.createElement(Checkbox, {
                    checked: checked,
                    onChange: Expln_React_common.evt2bool(onChange)
                  }),
              label: label,
              style: {
                border: "solid 1px lightgrey",
                paddingRight: "10px",
                borderRadius: "7px"
              }
            });
}

var startedForApiCalls = [];

function MM_cmp_unify_bottom_up(props) {
  var onCancel = props.onCancel;
  var onResultSelected = props.onResultSelected;
  var selectFirstFoundProof = props.selectFirstFoundProof;
  var delayBeforeStartMs = props.delayBeforeStartMs;
  var apiCallStartTime = props.apiCallStartTime;
  var initialDebugLevel = props.initialDebugLevel;
  var initialParams = props.initialParams;
  var typeToPrefix = props.typeToPrefix;
  var reservedLabels = props.reservedLabels;
  var rootStmts = props.rootStmts;
  var wrkCtx = props.wrkCtx;
  var disjText = props.disjText;
  var varsText = props.varsText;
  var parenCnt = props.parenCnt;
  var frms = props.frms;
  var preCtx = props.preCtx;
  var preCtxVer = props.preCtxVer;
  var settings = props.settings;
  var settingsVer = props.settingsVer;
  var modalRef = props.modalRef;
  var match = React.useState(function () {
        return makeInitialState(rootStmts, frms, parenCnt, initialParams, initialDebugLevel, settings.allowedFrms, settings.bottomUpProverDefaults);
      });
  var setState = match[1];
  var state = match[0];
  var isApiCall = Belt_Option.isSome(apiCallStartTime);
  var match$1 = state.results;
  var onlyOneResultIsAvailable = match$1 !== undefined && match$1.TAG === "Ok" ? match$1._0.length === 1 : false;
  var actLabelUpdated = function (label) {
    setState(function (__x) {
          return setLabel(__x, label);
        });
  };
  var actDepthUpdated = function (depthStr) {
    setState(function (__x) {
          return setDepthStr(__x, depthStr.replace(nonDigitPattern, ""));
        });
  };
  var makeActTerminate = function (modalId) {
    return function () {
      MM_wrk_client.terminateWorker();
      Expln_React_Modal.closeModal(modalRef, modalId);
    };
  };
  var getFrmLabelBkgColor = function (label) {
    var frm = MM_substitution.frmsGetByLabel(frms, label);
    if (frm !== undefined) {
      return MM_react_common.getFrmLabelBkgColor(frm.frame, settings);
    }
    
  };
  var getEffectiveProverParams = function (state) {
    if (isApiCall) {
      return state.initialParams;
    }
    var deriveFromOnLevel0 = state.rootStmtsRendered.filter(function (param, i) {
            return state.args0[i];
          }).map(function (stmt) {
          return stmt.expr;
        });
    return MM_bottom_up_prover_params.bottomUpProverParamsMakeDefault(state.label, state.depth, state.lengthRestrict, state.allowNewDisjForExistingVars, state.allowNewStmts, state.allowNewVars, deriveFromOnLevel0, state.args1EqArgs0 ? deriveFromOnLevel0 : state.rootStmtsRendered.filter(function (param, i) {
                        return state.args1[i];
                      }).map(function (stmt) {
                      return stmt.expr;
                    }), state.debugLevel === 0 || state.maxNumberOfBranchesStr === "" ? undefined : Belt_Int.fromString(state.maxNumberOfBranchesStr));
  };
  var getEffectiveProverParamsToShow = function (state, params) {
    return {
            stepToProve: state.rootStmts[state.rootStmts.length - 1 | 0].label,
            debugLevel: state.debugLevel,
            customParams: params.customParams,
            maxSearchDepth: params.maxSearchDepth,
            assertionParams: params.assertionParams.map(function (p) {
                  return {
                          minDist: p.minDist,
                          maxDist: p.maxDist,
                          assertionsToUse: p.assertionsToUse,
                          matches: Belt_Option.map(p.matches, (function (__x) {
                                  return __x.map(function (matcher) {
                                              return {
                                                      res: matcher.matchAsrt ? MM_context.frmIntsToStrExn(wrkCtx, matcher.frm.frame, matcher.frm.frame.asrt) : undefined,
                                                      hyps: matcher.hypMatchers.map(function (hypMatcher, i) {
                                                            var match;
                                                            match = hypMatcher.TAG === "Label" ? [
                                                                hypMatcher._0,
                                                                undefined
                                                              ] : [
                                                                undefined,
                                                                hypMatcher._0
                                                              ];
                                                            return {
                                                                    label: match[0],
                                                                    idx: match[1],
                                                                    pat: MM_context.frmIntsToStrExn(wrkCtx, matcher.frm.frame, matcher.frm.hypsE[i].expr)
                                                                  };
                                                          })
                                                    };
                                            });
                                })),
                          stepsToDeriveFrom: p.deriveFrom.map(function (__x) {
                                var stmt = state.rootStmtsRendered.find(function (stmt) {
                                      return MM_context.exprEq(__x, stmt.expr);
                                    });
                                if (stmt !== undefined) {
                                  return stmt.label;
                                }
                                throw {
                                      RE_EXN_ID: Common.MmException,
                                      _1: {
                                        msg: "Could not find a label for an expression in MM_cmp_unify_bottom_up.exprToLabel()"
                                      },
                                      Error: new Error()
                                    };
                              }),
                          allowNewDisjointsForExistingVariables: p.allowNewDisjointsForExistingVariables,
                          allowNewStatements: p.allowNewStatements,
                          allowNewVariables: p.allowNewVariables,
                          statementLengthRestriction: MM_bottom_up_prover_params.lengthRestrictToStr(p.statementLengthRestriction),
                          maxNumberOfBranches: p.maxNumberOfBranches
                        };
                }),
            updateParams: params.updateParamsStr
          };
  };
  var actProve = function () {
    setState(function (st) {
          var depthStr = st.depthStr.trim();
          var st$1;
          if (depthStr.length === 0) {
            var newrecord = Caml_obj.obj_dup(st);
            newrecord.depthStr = "1";
            newrecord.depth = 1;
            st$1 = newrecord;
          } else {
            var depth = Math.max(Belt_Option.getWithDefault(Belt_Int.fromString(depthStr), 1), 1);
            var depthStr$1 = String(depth);
            var newrecord$1 = Caml_obj.obj_dup(st);
            newrecord$1.depthStr = depthStr$1;
            newrecord$1.depth = depth;
            st$1 = newrecord$1;
          }
          var effectiveProverParams = getEffectiveProverParams(st$1);
          var paramsToShow = getEffectiveProverParamsToShow(st$1, effectiveProverParams);
          var debugLevel = st$1.debugLevel;
          var newrecord$2 = Caml_obj.obj_dup(st$1);
          newrecord$2.proverParamsToShow = paramsToShow;
          Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function () {
                      return MM_react_common.rndProgress("Proving bottom-up", 0, undefined);
                    })), (function (modalId) {
                  Expln_React_Modal.updateModal(modalRef, modalId, (function () {
                          return MM_react_common.rndProgress("Proving bottom-up", 0, makeActTerminate(modalId));
                        }));
                  return Expln_utils_promise.promiseMap(MM_wrk_unify.unify(settingsVer, settings, preCtxVer, preCtx, varsText, disjText, state.rootStmts, effectiveProverParams, {
                                  inSyntax: settings.allowedFrms.inSyntax,
                                  inEssen: {
                                    useDisc: state.useDisc,
                                    useDepr: state.useDepr,
                                    useTranDepr: state.useTranDepr
                                  }
                                }, undefined, undefined, debugLevel, (function (msg) {
                                    Expln_React_Modal.updateModal(modalRef, modalId, (function () {
                                            return MM_react_common.rndProgress(msg, undefined, makeActTerminate(modalId));
                                          }));
                                  })), (function (proofTreeDto) {
                                Expln_React_Modal.closeModal(modalRef, modalId);
                                var rootExprToLabel = Belt_HashMap.fromArray(state.rootStmts.map(function (stmt) {
                                          return [
                                                  stmt.expr,
                                                  stmt.label
                                                ];
                                        }), MM_context.ExprHash);
                                if (proofTreeDto.TAG === "Ok") {
                                  var treeDto = proofTreeDto._0;
                                  var results = MM_wrk_unify.proofTreeDtoToNewStmtsDto(treeDto, state.exprToProve, wrkCtx, typeToPrefix, rootExprToLabel, reservedLabels);
                                  return setState(function (st) {
                                              return setResults(st, st.debugLevel > 0 ? treeDto : undefined, findWarnings(treeDto), {
                                                          TAG: "Ok",
                                                          _0: results
                                                        }, getFrmLabelBkgColor);
                                            });
                                }
                                var msg = proofTreeDto._0;
                                setState(function (st) {
                                      return setResults(st, undefined, [], {
                                                  TAG: "Error",
                                                  _0: msg
                                                }, getFrmLabelBkgColor);
                                    });
                              }));
                }));
          return newrecord$2;
        });
  };
  React.useEffect((function () {
          if (apiCallStartTime !== undefined) {
            var apiCallStartTimeStr = Caml_option.valFromOption(apiCallStartTime).toISOString();
            if (!startedForApiCalls.includes(apiCallStartTimeStr)) {
              startedForApiCalls.push(apiCallStartTimeStr);
              startedForApiCalls.splice(0, startedForApiCalls.length - 5 | 0);
              setTimeout((function () {
                      actProve();
                    }), delayBeforeStartMs);
            }
            
          }
          
        }), []);
  var actChooseSelected = function (idxToSelect) {
    var match = state.results;
    if (match === undefined) {
      return ;
    }
    if (match.TAG !== "Ok") {
      return ;
    }
    var results = match._0;
    if (onlyOneResultIsAvailable) {
      setState(setResultForApiCallHasBeenSelected);
      return onResultSelected({
                  TAG: "Ok",
                  _0: results[0]
                });
    }
    if (idxToSelect !== undefined) {
      setState(setResultForApiCallHasBeenSelected);
      return onResultSelected({
                  TAG: "Ok",
                  _0: results[idxToSelect]
                });
    }
    var checkedResultIdx = state.checkedResultIdx;
    if (checkedResultIdx !== undefined) {
      setState(setResultForApiCallHasBeenSelected);
      return onResultSelected({
                  TAG: "Ok",
                  _0: results[checkedResultIdx]
                });
    } else {
      return Core__Option.forEach(state.resultsSorted, (function (resultsSorted) {
                    setState(setResultForApiCallHasBeenSelected);
                    onResultSelected({
                          TAG: "Ok",
                          _0: results[resultsSorted[0].idx]
                        });
                  }));
    }
  };
  React.useEffect((function () {
          if (isApiCall && !state.resultForApiCallHasBeenSelected) {
            var resultsSorted = state.resultsSorted;
            if (resultsSorted !== undefined) {
              setState(setResultForApiCallHasBeenSelected);
              if (selectFirstFoundProof !== undefined) {
                if (selectFirstFoundProof && resultsSorted.length > 0 && resultsSorted[0].isProved) {
                  actChooseSelected(resultsSorted[0].idx);
                } else {
                  onResultSelected(undefined);
                }
              } else if (resultsSorted.length > 0 && resultsSorted[0].isProved) {
                actChooseSelected(resultsSorted[0].idx);
              } else {
                onResultSelected(undefined);
              }
            } else {
              var match = state.results;
              if (match !== undefined) {
                if (match.TAG === "Ok") {
                  Js_exn.raiseError("Internal error: state.resultsSorted is None, but state.results is Some(Ok(_))");
                } else {
                  setState(setResultForApiCallHasBeenSelected);
                  onResultSelected({
                        TAG: "Error",
                        _0: match._0
                      });
                }
              }
              
            }
          }
          
        }), [
        state.results,
        state.resultsSorted
      ]);
  var actShowProofTree = function () {
    var tree = state.tree;
    if (tree !== undefined) {
      Expln_utils_promise.promiseMap(Expln_React_Modal.openModalFullScreen(modalRef, (function () {
                  return null;
                })), (function (modalId) {
              Expln_React_Modal.updateModal(modalRef, modalId, (function () {
                      var closeBtn = React.createElement(Button, {
                            onClick: (function (param) {
                                Expln_React_Modal.closeModal(modalRef, modalId);
                              }),
                            variant: "outlined",
                            children: "Close"
                          });
                      return React.createElement(Expln_React_Column.make, {
                                  spacing: 1,
                                  style: {
                                    margin: "5px"
                                  },
                                  children: Caml_option.some(null)
                                }, closeBtn, React.createElement(MM_cmp_proof_tree.make, {
                                      tree: tree,
                                      rootExpr: state.exprToProve,
                                      settings: settings,
                                      wrkCtx: wrkCtx,
                                      rootStmts: state.rootStmts
                                    }), closeBtn);
                    }));
            }));
      return ;
    }
    
  };
  var actMaxNumberOfBranchesStrUpdated = function (maxNumberOfBranchesStr) {
    setState(function (__x) {
          return setMaxNumberOfBranchesStr(__x, maxNumberOfBranchesStr);
        });
  };
  var rndLengthRestrictSelector = function (value) {
    return React.createElement(FormControl, {
                size: "small",
                children: Caml_option.some(null)
              }, React.createElement(InputLabel, {
                    id: "length-restrict-select-label",
                    children: "Statement length restriction"
                  }), React.createElement(Select, {
                    sx: {
                      width: 190
                    },
                    labelId: "length-restrict-select-label",
                    label: "Statement length restriction",
                    value: MM_bottom_up_prover_params.lengthRestrictToStr(value),
                    onChange: Expln_React_common.evt2str(function (str) {
                          var lengthRestrict = MM_bottom_up_prover_params.lengthRestrictFromStrExn(str);
                          setState(function (__x) {
                                return setLengthRestrict(__x, lengthRestrict);
                              });
                        }),
                    children: Caml_option.some(null)
                  }, React.createElement(MenuItem, {
                        value: "No",
                        children: "Unrestricted"
                      }), React.createElement(MenuItem, {
                        value: "LessEq",
                        children: "LessEq"
                      }), React.createElement(MenuItem, {
                        value: "Less",
                        children: "Less"
                      })));
  };
  var rndSortBySelector = function () {
    var match = state.results;
    if (match !== undefined && match.TAG === "Ok" && match._0.length >= 2) {
      return React.createElement(FormControl, {
                  size: "small",
                  children: Caml_option.some(null)
                }, React.createElement(InputLabel, {
                      id: "sortBy-select-label",
                      children: "Sort results by"
                    }), React.createElement(Select, {
                      labelId: "sortBy-select-label",
                      label: "Sort results by",
                      value: sortByToStr(state.sortBy),
                      onChange: Expln_React_common.evt2str(function (str) {
                            var sortBy = sortByFromStr(str);
                            setState(function (__x) {
                                  return setSortBy(__x, sortBy);
                                });
                          }),
                      children: Caml_option.some(null)
                    }, React.createElement(MenuItem, {
                          value: "NewStmtsNum",
                          children: "Number of new steps"
                        }), React.createElement(MenuItem, {
                          value: "UnprovedStmtsNum",
                          children: "Number of unproved steps"
                        }), React.createElement(MenuItem, {
                          value: "NumOfNewVars",
                          children: "Number of new variables"
                        }), React.createElement(MenuItem, {
                          value: "AsrtLabel",
                          children: "Assertion label"
                        })));
    } else {
      return null;
    }
  };
  var rndDebugParam = function () {
    return React.createElement(Expln_React_Row.make, {
                alignItems: "center",
                children: Caml_option.some(null)
              }, "Logging level", React.createElement(RadioGroup, {
                    value: String(state.debugLevel),
                    onChange: Expln_React_common.evt2str(function (str) {
                          var debugLevel = Belt_Option.getExn(Belt_Int.fromString(str));
                          setState(function (__x) {
                                return setDebugLevel(__x, debugLevel);
                              });
                        }),
                    row: true,
                    children: Caml_option.some(null)
                  }, React.createElement(FormControlLabel, {
                        control: React.createElement(Radio, {}),
                        label: "0",
                        value: "0"
                      }), React.createElement(FormControlLabel, {
                        control: React.createElement(Radio, {}),
                        label: "1",
                        value: "1"
                      }), React.createElement(FormControlLabel, {
                        control: React.createElement(Radio, {}),
                        label: "2",
                        value: "2"
                      })));
  };
  var rndParamsForUsualCall = function () {
    if (state.availableLabels.length === 0) {
      return React.createElement(Expln_React_Column.make, {
                  children: Caml_option.some(null)
                }, "The statement to prove doesn't match any existing assertion. Bottom-up proving is not available for such statements.", React.createElement(Button, {
                      onClick: (function (param) {
                          onCancel();
                        }),
                      children: "Ok"
                    }));
    } else {
      return React.createElement(Expln_React_Column.make, {
                  children: Caml_option.some(null)
                }, React.createElement(Expln_React_Row.make, {
                      children: Caml_option.some(null)
                    }, React.createElement(AutocompleteVirtualized.make, {
                          value: state.label,
                          options: state.availableLabels,
                          onChange: actLabelUpdated,
                          size: "small",
                          width: 200,
                          label: "Label of root justification"
                        }), React.createElement(TextField, {
                          value: state.depthStr,
                          label: "Search depth",
                          size: "small",
                          style: {
                            width: "100px"
                          },
                          onChange: Expln_React_common.evt2str(actDepthUpdated),
                          onKeyDown: MM_react_common.kbrdHnd2(MM_react_common.kbrdClbkMake(MM_react_common.keyEnter, undefined, undefined, undefined, actProve), MM_react_common.kbrdClbkMake(MM_react_common.keyEsc, undefined, undefined, undefined, onCancel)),
                          autoFocus: true
                        }), rndLengthRestrictSelector(state.lengthRestrict)), React.createElement(Expln_React_Row.make, {
                      children: Caml_option.some(null)
                    }, React.createElement(FormControlLabel, {
                          control: React.createElement(Checkbox, {
                                checked: state.allowNewDisjForExistingVars,
                                onChange: (function (param) {
                                    setState(toggleAllowNewDisjForExistingVars);
                                  })
                              }),
                          label: "Allow new disjoints",
                          style: {
                            border: "solid 1px lightgrey",
                            marginTop: "-2px",
                            marginLeft: "2px",
                            paddingRight: "10px",
                            borderRadius: "7px"
                          }
                        }), React.createElement(FormControlLabel, {
                          control: React.createElement(Checkbox, {
                                checked: state.allowNewStmts,
                                onChange: (function (param) {
                                    setState(toggleAllowNewStmts);
                                  })
                              }),
                          label: "Allow new steps",
                          style: {
                            border: "solid 1px lightgrey",
                            marginTop: "-2px",
                            marginLeft: "2px",
                            paddingRight: "10px",
                            borderRadius: "7px"
                          }
                        }), React.createElement(FormControlLabel, {
                          control: React.createElement(Checkbox, {
                                checked: state.allowNewVars,
                                onChange: (function (param) {
                                    setState(toggleAllowNewVars);
                                  })
                              }),
                          label: "Allow new variables",
                          disabled: !state.allowNewStmts,
                          style: {
                            border: "solid 1px lightgrey",
                            marginTop: "-2px",
                            paddingRight: "10px",
                            borderRadius: "7px"
                          }
                        })), React.createElement("table", undefined, React.createElement("tbody", undefined, React.createElement("tr", undefined, React.createElement("td", undefined, "Allow usage of assertions:"), React.createElement("td", {
                                  style: {
                                    paddingLeft: "10px"
                                  }
                                }, rndCheckboxWithLabelAndBorder(state.useDisc, (function (param) {
                                        setState(toggleUseDisc);
                                      }), "discouraged")), React.createElement("td", undefined, rndCheckboxWithLabelAndBorder(state.useDepr, (function (param) {
                                        setState(toggleUseDepr);
                                      }), "deprecated")), React.createElement("td", undefined, rndCheckboxWithLabelAndBorder(state.useTranDepr, (function (param) {
                                        setState(toggleUseTranDepr);
                                      }), "transitively deprecated"))))), React.createElement(Expln_React_Row.make, {
                      children: Caml_option.some(null)
                    }, rndDebugParam(), React.createElement(TextField, {
                          value: state.maxNumberOfBranchesStr,
                          label: "Max num of branches",
                          size: "small",
                          style: {
                            width: "200px"
                          },
                          onChange: Expln_React_common.evt2str(actMaxNumberOfBranchesStrUpdated),
                          onKeyDown: MM_react_common.kbrdHnd2(MM_react_common.kbrdClbkMake(MM_react_common.keyEnter, undefined, undefined, undefined, actProve), MM_react_common.kbrdClbkMake(MM_react_common.keyEsc, undefined, undefined, undefined, onCancel)),
                          disabled: state.debugLevel === 0
                        })), React.createElement(Expln_React_Row.make, {
                      children: Caml_option.some(null)
                    }, React.createElement(Button, {
                          onClick: (function (param) {
                              actProve();
                            }),
                          variant: "contained",
                          color: "grey",
                          children: "Prove"
                        }), React.createElement(Button, {
                          onClick: (function (param) {
                              onCancel();
                            }),
                          children: "Cancel"
                        })));
    }
  };
  var rndActualProverParams = function () {
    var proverParamsToShow = state.proverParamsToShow;
    if (proverParamsToShow !== undefined) {
      return React.createElement(TextField, {
                  value: Expln_utils_common.stringify(proverParamsToShow),
                  label: "Actual parameters of the bottom-up prover",
                  size: "small",
                  style: {
                    width: "800px"
                  },
                  multiline: true,
                  rows: 10,
                  disabled: true,
                  autoFocus: false
                });
    } else {
      return null;
    }
  };
  var rndParamsForApiCall = function () {
    var match = state.proverParamsToShow;
    return React.createElement(Expln_React_Column.make, {
                children: Caml_option.some(null)
              }, match !== undefined ? (
                  state.showApiParams ? rndActualProverParams() : null
                ) : "Starting...", React.createElement(Expln_React_Row.make, {
                    children: Caml_option.some(null)
                  }, React.createElement(Button, {
                        onClick: (function (param) {
                            setState(toggleShowApiParams);
                          }),
                        children: Caml_option.some(state.showApiParams ? "Hide parameters" : "Show parameters")
                      }), React.createElement(Button, {
                        onClick: (function (param) {
                            onCancel();
                          }),
                        children: "Close"
                      })));
  };
  var rndParams = function () {
    if (isApiCall) {
      return rndParamsForApiCall();
    } else {
      return rndParamsForUsualCall();
    }
  };
  var rndPagination = function (totalNumOfResults) {
    if (state.resultsPerPage < totalNumOfResults) {
      return React.createElement(Pagination, {
                  count: state.resultsMaxPage,
                  page: state.resultsPage,
                  onChange: (function (param, newPage) {
                      setState(function (__x) {
                            return setPage(__x, newPage);
                          });
                    })
                });
    } else {
      return null;
    }
  };
  var rndApplyButton = function () {
    return React.createElement(Button, {
                onClick: (function (param) {
                    actChooseSelected(undefined);
                  }),
                variant: "contained",
                children: Caml_option.some(onlyOneResultIsAvailable ? "Apply" : (
                        Belt_Option.isNone(state.checkedResultIdx) ? "Apply first" : "Apply selected"
                      ))
              });
  };
  var rndShowProofTreeBtn = function () {
    var match = state.tree;
    if (match !== undefined) {
      return React.createElement(Button, {
                  onClick: (function (param) {
                      actShowProofTree();
                    }),
                  variant: "outlined",
                  children: "Show proof tree"
                });
    } else {
      return null;
    }
  };
  var rndWarningsBtn = function (warnings) {
    if (warnings.length === 0) {
      return null;
    } else {
      return React.createElement(IconButton, {
                  onClick: (function (param) {
                      Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function () {
                                  return null;
                                })), (function (modalId) {
                              Expln_React_Modal.updateModal(modalRef, modalId, (function () {
                                      return React.createElement(Paper, {
                                                  style: {
                                                    padding: "10px"
                                                  },
                                                  children: Caml_option.some(React.createElement(Expln_React_Column.make, {
                                                            children: Caml_option.some(null)
                                                          }, React.createElement("ol", undefined, warnings.map(function (msg, i) {
                                                                    return React.createElement("li", {
                                                                                key: String(i)
                                                                              }, msg);
                                                                  })), React.createElement(Button, {
                                                                onClick: (function (param) {
                                                                    Expln_React_Modal.closeModal(modalRef, modalId);
                                                                  }),
                                                                variant: "contained",
                                                                children: "Close"
                                                              })))
                                                });
                                    }));
                            }));
                    }),
                  color: "yellow",
                  title: "There are warnings, click to see details",
                  children: Caml_option.some(React.createElement(Warning, {}))
                });
    }
  };
  var actShowActualParams = function () {
    Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function () {
                return null;
              })), (function (modalId) {
            Expln_React_Modal.updateModal(modalRef, modalId, (function () {
                    return React.createElement(Paper, {
                                style: {
                                  padding: "10px"
                                },
                                children: Caml_option.some(React.createElement(Expln_React_Column.make, {
                                          children: Caml_option.some(null)
                                        }, rndActualProverParams(), React.createElement(Button, {
                                              onClick: (function (param) {
                                                  Expln_React_Modal.closeModal(modalRef, modalId);
                                                }),
                                              variant: "outlined",
                                              children: "Close"
                                            })))
                              });
                  }));
          }));
  };
  var rndShowActualParamsBtn = function () {
    return React.createElement(IconButton, {
                onClick: (function (param) {
                    actShowActualParams();
                  }),
                title: "Show actual parameters of the bottom-up prover",
                children: Caml_option.some(React.createElement(DisplaySettings, {}))
              });
  };
  var rndResults = function () {
    var resultsSorted = state.resultsSorted;
    if (resultsSorted !== undefined) {
      var totalNumOfResults = resultsSorted.length;
      if (totalNumOfResults === 0) {
        return React.createElement(Expln_React_Column.make, {
                    children: Caml_option.some(null)
                  }, React.createElement(Divider, {}), React.createElement(Expln_React_Row.make, {
                        children: Caml_option.some(null)
                      }, "Nothing found.", rndShowProofTreeBtn(), rndWarningsBtn(state.warnings), rndShowActualParamsBtn()));
      }
      var start = Math.imul(state.resultsPage - 1 | 0, state.resultsPerPage);
      var items = resultsSorted.slice(start, start + state.resultsPerPage | 0);
      return React.createElement(Expln_React_Column.make, {
                  children: Caml_option.some(null)
                }, React.createElement(Divider, {}), React.createElement(Expln_React_Row.make, {
                      alignItems: "center",
                      children: Caml_option.some(null)
                    }, rndApplyButton(), rndSortBySelector(), rndPagination(totalNumOfResults), rndShowProofTreeBtn(), rndWarningsBtn(state.warnings), rndShowActualParamsBtn()), items.map(function (item) {
                      return React.createElement("table", {
                                  key: String(item.idx)
                                }, React.createElement("tbody", undefined, React.createElement("tr", undefined, onlyOneResultIsAvailable ? null : React.createElement("td", undefined, React.createElement(Checkbox, {
                                                    checked: Belt_Option.getWithDefault(Belt_Option.map(state.checkedResultIdx, (function (idx) {
                                                                return idx === item.idx;
                                                              })), false),
                                                    onChange: (function (param) {
                                                        var idx = item.idx;
                                                        setState(function (__x) {
                                                              return toggleResultChecked(__x, idx);
                                                            });
                                                      })
                                                  })), React.createElement("td", undefined, React.createElement(Paper, {
                                                  children: Caml_option.some(item.elem)
                                                })))));
                    }), rndPagination(totalNumOfResults), rndApplyButton());
    }
    var match = state.results;
    if (match !== undefined) {
      if (match.TAG === "Ok") {
        return Js_exn.raiseError("Internal error: state.resultsSorted is None, but state.results is Some(Ok(_))");
      } else {
        return React.createElement(Expln_React_Column.make, {
                    children: Caml_option.some(null)
                  }, React.createElement("pre", {
                        style: {
                          color: "red"
                        }
                      }, "Error:"), React.createElement("pre", undefined, match._0));
      }
    } else {
      return null;
    }
  };
  var rndRootStmtsForLevelShort = function (title, titleOnly, dialogTitle, stmtToProve, getFlags, setFlags) {
    if (titleOnly) {
      return React.createElement(Expln_React_Row.make, {
                  style: {
                    border: "solid lightgrey 1px",
                    margin: "2px",
                    borderRadius: "6px"
                  },
                  children: Caml_option.some(title)
                });
    }
    var flags = getFlags(state);
    var allSelected = flags.every(function (b) {
          return b;
        });
    var noneSelected = flags.every(function (b) {
          return !b;
        });
    var numberOfSelected;
    if (allSelected) {
      numberOfSelected = "All";
    } else if (noneSelected) {
      numberOfSelected = "None";
    } else {
      var numSelected = Core__Array.reduce(flags, 0, (function (cnt, b) {
              if (b) {
                return cnt + 1 | 0;
              } else {
                return cnt;
              }
            }));
      var numAll = flags.length;
      numberOfSelected = String(numSelected) + "/" + String(numAll);
    }
    var match = noneSelected ? [
        "select all",
        (function () {
            setFlags(flags.map(function (param) {
                      return true;
                    }));
          })
      ] : [
        "select none",
        (function () {
            setFlags(flags.map(function (param) {
                      return false;
                    }));
          })
      ];
    var selectUnselectAct = match[1];
    return React.createElement(Expln_React_Row.make, {
                style: {
                  border: "solid lightgrey 1px",
                  margin: "2px",
                  borderRadius: "6px"
                },
                children: Caml_option.some(null)
              }, title, React.createElement("span", {
                    style: {
                      color: "blue",
                      cursor: "pointer"
                    },
                    onClick: (function (param) {
                        var proofStatusesAreAvailable = state.rootStmtsRendered.every(function (stmt) {
                              return Belt_Option.isSome(getProofStatus(stmt));
                            });
                        Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function () {
                                    return null;
                                  })), (function (modalId) {
                                Expln_React_Modal.updateModal(modalRef, modalId, (function () {
                                        return React.createElement(MM_cmp_root_stmts.make, {
                                                    title: dialogTitle,
                                                    stmtToProve: stmtToProve,
                                                    rootStmtsRendered: state.rootStmtsRendered,
                                                    proofStatusesAreAvailable: proofStatusesAreAvailable,
                                                    flags: getFlags(state),
                                                    onClose: (function (newFlags) {
                                                        setFlags(newFlags);
                                                        Expln_React_Modal.closeModal(modalRef, modalId);
                                                      })
                                                  });
                                      }));
                              }));
                      })
                  }, numberOfSelected), React.createElement("span", {
                    style: {
                      backgroundColor: "rgb(240, 240, 240)",
                      border: "solid lightgrey 0px",
                      cursor: "pointer",
                      paddingRight: "5px",
                      paddingLeft: "5px",
                      borderRadius: "10px"
                    },
                    onClick: (function (param) {
                        selectUnselectAct();
                      })
                  }, match[0]));
  };
  var rndRootStmts = function () {
    if (state.rootStmtsRendered.length === 0) {
      return null;
    } else {
      return React.createElement(Expln_React_Row.make, {
                  alignItems: "center",
                  spacing: 0.2,
                  children: Caml_option.some(null)
                }, "Allowed statements: ", rndRootStmtsForLevelShort("first level", false, "Select steps to derive from on level 0", state.title, (function (state) {
                        return state.args0;
                      }), (function (newFlags) {
                        setState(function (__x) {
                              return updateArgs0(__x, newFlags);
                            });
                      })), React.createElement(IconButton, {
                      onClick: (function (param) {
                          setState(toggleArgs1EqArgs0);
                        }),
                      color: state.args1EqArgs0 ? "primary" : "lightgrey",
                      title: "Set allowed statements for other levels same as for the first level",
                      children: Caml_option.some(React.createElement(Pause, {
                                style: {
                                  transform: "rotate(-90deg)"
                                }
                              }))
                    }), rndRootStmtsForLevelShort(state.args1EqArgs0 ? "other levels: same as first level" : "other levels", state.args1EqArgs0, "Select steps to derive from on other levels", state.title, (function (state) {
                        return state.args1;
                      }), (function (newFlags) {
                        setState(function (__x) {
                              return updateArgs1(__x, newFlags);
                            });
                      })));
    }
  };
  return React.createElement(Paper, {
              style: {
                padding: "10px"
              },
              children: Caml_option.some(React.createElement(Expln_React_Column.make, {
                        spacing: 1.5,
                        children: Caml_option.some(null)
                      }, state.title, isApiCall ? null : rndRootStmts(), rndParams(), rndResults()))
            });
}

var make = MM_cmp_unify_bottom_up;

exports.getProofStatus = getProofStatus;
exports.exprMayMatchAsrt = exprMayMatchAsrt;
exports.getAvailableAsrtLabels = getAvailableAsrtLabels;
exports.makeInitialState = makeInitialState;
exports.setLabel = setLabel;
exports.setDepthStr = setDepthStr;
exports.setLengthRestrict = setLengthRestrict;
exports.toggleAllowNewDisjForExistingVars = toggleAllowNewDisjForExistingVars;
exports.toggleAllowNewStmts = toggleAllowNewStmts;
exports.toggleAllowNewVars = toggleAllowNewVars;
exports.toggleArgs1EqArgs0 = toggleArgs1EqArgs0;
exports.toggleUseDisc = toggleUseDisc;
exports.toggleUseDepr = toggleUseDepr;
exports.toggleUseTranDepr = toggleUseTranDepr;
exports.setDebugLevel = setDebugLevel;
exports.toggleShowApiParams = toggleShowApiParams;
exports.setResultForApiCallHasBeenSelected = setResultForApiCallHasBeenSelected;
exports.nonDigitPattern = nonDigitPattern;
exports.setMaxNumberOfBranchesStr = setMaxNumberOfBranchesStr;
exports.selectAllArgs = selectAllArgs;
exports.unselectAllArgs = unselectAllArgs;
exports.updateArgs0 = updateArgs0;
exports.updateArgs1 = updateArgs1;
exports.isStmtToShow = isStmtToShow;
exports.stmtsDtoToResultRendered = stmtsDtoToResultRendered;
exports.compareByIsProved = compareByIsProved;
exports.compareByNumberOfStmts = compareByNumberOfStmts;
exports.compareByNumOfUnprovedStmts = compareByNumOfUnprovedStmts;
exports.compareByNumOfNewStmts = compareByNumOfNewStmts;
exports.compareByNumOfNewVars = compareByNumOfNewVars;
exports.compareByAsrtLabel = compareByAsrtLabel;
exports.createComparator = createComparator;
exports.sortResultsRendered = sortResultsRendered;
exports.isTruncatedSearchErr = isTruncatedSearchErr;
exports.findWarnings = findWarnings;
exports.setResults = setResults;
exports.setSortBy = setSortBy;
exports.setPage = setPage;
exports.toggleResultChecked = toggleResultChecked;
exports.sortByToStr = sortByToStr;
exports.sortByFromStr = sortByFromStr;
exports.rndCheckboxWithLabelAndBorder = rndCheckboxWithLabelAndBorder;
exports.startedForApiCalls = startedForApiCalls;
exports.make = make;
/* compareByIsProved Not a pure module */
